import { loadStripe } from "@stripe/stripe-js";

export const stripePromise = loadStripe(
    "pk_live_51PcrSlLr2aswQ4WxmkHpjHcrO9nI6Wt3AqMUwMqlUJYLvs9eGlLrIaMs32hanUfx18Bi5RF92aqsIEM5gm47keIX00g4mmF3Vz"
);
